import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class UserWalletService {
  constructor(private http: HttpClient) {}

  getUserWithdrawalReq(data: any) {
    return this.http.post(
      environment.apiUrl + "user/withdrawalrequest/get",
      data
    );
  }

  updateUserWithdrawalReq(data: any) {
    return this.http.post(
      environment.apiUrl + "user/withdrawalrequest/update",
      data
    );
  }

  searchWalletRequest(data: any) {
    return this.http.post(
      environment.apiUrl + "user/withdrawalrequest/search",
      data
    );
  }
  userDeposite(data: any) {
    return this.http.post(
      environment.apiUrl + "user/deposittransaction/get",
      data
    );
  }

  getUserWalletTransactions(data: any) {
    return this.http.post(environment.apiUrl + "user/wallettransaction", data);
  }
  userBalance(data: any) {
    return this.http.post(environment.apiUrl + "user/wallet", data);
  }

  userByID(data: any) {
    return this.http.post(
      environment.apiUrl + "userInformation/get/byId",
      data
    );
  }
}
